/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
import React, { useEffect, memo, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Col, Row, Label, Input } from 'reactstrap';
import moment from 'moment';
import {
  addAction,
  changeAction,
  disableAction,
  enableAction,
} from '../../../../../actions/BoxSessionLogging';
import {
  activateE2,
  activateE3,
  addPortForward,
  deactivateE2,
  deactivateE3,
  getDhcp,
  disableDHCP,
  enableDHCP,
  eSIMStatus,
  getPortList,
  updatePortForward,
  getNetworkConnectivatyStatus,
  triggerConnectivityStats, 
  fetchNetworkInfo,
  enableDisableEth3
} from '../../../../../actions/EpikBoxes';
import { TOOLTIPS_TEXT, ETH3_WARNING_TEXT } from '../../../../../lib/constants';
import InfoPopup from '../../../../InfoPopup';
import CustomModal from '../../../../CustomModal';
import TableRowData from '../../../../FulFillment/TableRowData';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';
import Spinner from '../../../../Spinner/Spinner';
import PortForwardUpdate from '../EpikboxOptions/PortForwardUpdate';
import './EpikboxNetworking.css';
import NetworkInput from './NetworkInput';
import useEpikboxNetworking from './useEpikboxNetworking';
import utils from '../../../../../lib/utils';
import Toggle from '../../../../Toggle';
import ConfirmationModal from '../../../../ConfirmationModal';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import { PIN_CODES_NAME } from '../../../../../utils/constants';

const EpikboxNetworking = memo(() => {
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user);
  const token = localStorage.getItem('jwtToken') || '';
  const dispatch = useDispatch();
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });

  const [updatedBoxDetails, setUpdatedBoxDetails] = useState(boxDetails);
  const [networkInfo, setNetworkInfo] = useState({});
  const [e1Strings, setE1Strings] = useState(
    boxDetails?.e2 || {
      enabled: false,
      IP: '',
      subnet: '',
      gateway: '',
    },
  );
  const [e2Strings, setE2Strings] = useState({
    enabled: true,
    IP: '172.17.17.100',
    subnet: '255.255.255.0',
    gateway: '172.17.17.254',
  });

  const [warningModal, setWarningModal] = useState(false);
  const [warningModalText, setWarningModalText] = useState('');
  const [passwordModal, setPasswordModal] = useState(false);

  const {
    mode,
    sec,
    loading,
    modeDropDown,
    secDropDown,
    showWifiSection,
    wifiStatus,
    handleDropDownChange,
    setWifiStatus,
    handleConnectDisconnect,
  } = useEpikboxNetworking(boxDetails, token);

  // const [wifiObject, setWifiObject] = useState();
  const [e2Toggle, setE2Toggle] = useState(boxDetails?.e3);
  const [forwardingModal, setForwardingModal] = useState(false);
  const [portList, setPortList] = useState([]);
  const [portLoading, setPortLoading] = useState(false);
  const [enableE1Btn, setEnableE1Btn] = useState(true);
  const [eSimStatus, setESIMStatus] = useState(null);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [DHCPStatus, setDHCPStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModelGen4, setIsModelGen4] = useState(boxDetails?.model?.startsWith("G4"));
 
  const handleDeactivateE1 = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
    } else {
      if (e1Strings.enabled) {
        const res = await dispatch(deactivateE2(token, boxDetails._id));
        // eslint-disable-next-line no-console
        console.log('checking deactivate e2 response', res);
        if (res) {
          if (e1Strings.enabled) {
            // [Action]-Disable
            dispatch(disableAction('E1 IP Type change from enable to disable'));
          } else {
            // [Action] - Enable
            dispatch(enableAction('E1 IP Type change from disabled to enabled'));
          }
        }
      }
      setE1Strings({ ...e1Strings, enabled: !e1Strings.enabled });
    }
  };

  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
  };

  const handleDeactivateE2 = async () => {
    const divElement = document.getElementById('test-time-remaining');
    const isHidden = divElement.getAttribute('hidden') !== null;
    if (isHidden) {
      setDcUpdatePopup({ show: true });
    } else {
      setToggleLoading(true);
      if (DHCPStatus) {
        const res = await dispatch(disableDHCP(token, boxDetails.vpnAddress));
        // eslint-disable-next-line no-console
        console.log('checking deactivate e2 response', res);
        if (res) {
          const result = res.toLowerCase().includes('disab');
          setDHCPStatus(!result);
          dispatch(disableAction('E2 DHCP change from enable to disable'));
        }
      } else {
        const res = await dispatch(enableDHCP(token, boxDetails.vpnAddress));
        if (res) {
          const result = res.toLowerCase().includes('enable');
          setDHCPStatus(result);
          dispatch(enableAction('E2 DHCP change from disabled to enabled'));
        }
      }
      setToggleLoading(false);
    }
  };

  const dhcpStatus = async () => {
    const response = await dispatch(getDhcp(token, boxDetails.vpnAddress));
    if (response) {
      const result = response.toLowerCase().includes('enable');
      setDHCPStatus(result);
    }
  };

  const getNetworkStatus = async () => {
    setIsLoading(true);
    const data = await dispatch(getNetworkConnectivatyStatus(token, boxDetails?._id));
    if (data) {
      setNetworkInfo(data);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    dhcpStatus();
    if (!boxDetails.myEpik) {
      getNetworkStatus();
    }
  }, []);

  useEffect(() => {
    simStatus();
    setEth3Value(boxDetails?.eth3Disable)
  }, [boxDetails]);

  useEffect(() => {
    if (e1Strings.IP?.length > 0 && e1Strings.subnet?.length > 0 && e1Strings.gateway?.length > 0) {
      setEnableE1Btn(false);
    } else {
      setEnableE1Btn(true);
    }
  }, [e1Strings]);

  const one2InputChange = name => {
    const lastLetter = name.target.value.charAt(name.target.value?.length - 1);
    const numberCheck = !isNaN(lastLetter);
    if (numberCheck || lastLetter === '.') {
      setE1Strings({ ...e1Strings, [name.target.name]: name.target.value });
    } else {
      toast.error('Please enter number or dot');
    }
  };

  const handleE2Save = async () => {
    const res = await dispatch(activateE2(token, boxDetails._id, e1Strings));
    if (res) {
      if (boxDetails?.e2.IP && !e1Strings.IP) {
        // [Action] - Add
        dispatch(addAction('Static E1 IP Type added'));
      } else {
        // [Action] - Change
        dispatch(changeAction('Static E1 IP Type changed'));
      }
    }
  };

  const onEnableE2Toggle = async () => {
    if (updatedBoxDetails.e3) {
      const result = await dispatch(deactivateE3(token, boxDetails._id));
      if (result) {
        setUpdatedBoxDetails({ ...updatedBoxDetails, e3: !updatedBoxDetails.e3 });
        await dispatch(disableAction(`E2 toggle disabled`));
      }
    } else {
      const result = await dispatch(activateE3(token, boxDetails._id));
      if (result) {
        await dispatch(enableAction(`E2 toggle enabled`));
        setUpdatedBoxDetails({ ...updatedBoxDetails, e3: !updatedBoxDetails.e3 });
        setE2Toggle(true);
      }
    }
  };

  const onPortForwardPress = async () => {
    setPortLoading(true);
    const portListData = await dispatch(getPortList(token, boxDetails._id));
    setPortList(portListData);
    setPortLoading(false);
  };

  useMemo(() => {
    // eslint-disable-next-line no-unused-expressions
    !!portList?.length && setForwardingModal(true);
  }, [portList]);

  const onCallback = async (obj, type, index) => {
    setForwardingModal(false);
    // setIsExpandingBox(true);

    if (type === 'update') {
      const res = await dispatch(updatePortForward(token, boxDetails._id, index, obj));
      if (res) {
        // [Action]- Change
        dispatch(changeAction('update port forward'));
      }
    } else {
      const res = await dispatch(addPortForward(token, boxDetails._id, obj));
      if (res) {
        if (type === 'save') {
          // [Action]- Add
          dispatch(addAction('add port forwarding'));
        } else if (type === 'delete') {
          // [Action]- Change
          dispatch(changeAction('remove port forwarding'));
        }
      }
    }

    // setIsExpandingBox(false);
    setForwardingModal(true);
  };

  const simStatus = async () => {
    if (!boxDetails?.myEpik) {
      const data = await dispatch(eSIMStatus(token, boxDetails._id));
      if (typeof data === 'boolean') {
        setESIMStatus(data);
      } else {
        setESIMStatus(null);
      }
    }
  };

  const onInputChange = e => {
    setWifiStatus({ ...wifiStatus, [e.target.name]: e.target.value });
  };

  const isNumberKey = React.useCallback(evt => {
    const charCode = evt?.which ? evt?.which : evt?.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }, []);

  const checkThirdOctet = parseInt(boxDetails?.vpnAddress?.split('.')[2], 10) >= 20;

  const refreshConnectivityStats = async () => {
    if (!boxDetails?.myEpik) {
      setIsLoading(true);
      await dispatch(triggerConnectivityStats(token, boxDetails._id));
      setIsLoading(false);
    }
  };

  const [networkInfoLoading, setNetworkInfoLoading] = useState(false)
  const onRefreshNetworkInfo = async e => {
    e.preventDefault()
    setNetworkInfoLoading(true)
    await dispatch(fetchNetworkInfo(token, boxDetails?.vpnAddress));
    setTimeout(() => {
      setNetworkInfoLoading(false)
    }, 400);
  };

  const eth3PasswordHandler = () => {
    setWarningModal(true);
    setPasswordModal(false)
    setWarningModalText(ETH3_WARNING_TEXT);
    setPasswordModal(false)
  }
  const [e3loading, setE3Loading] = useState(false);
  const [eth3Value, setEth3Value] = useState(boxDetails?.eth3Disable);
  const onChangeEth3Value = async () => {
    const updatedEth3Value = !eth3Value;
    setWarningModal(false)
    setWarningModalText('')
    setE3Loading(true);
    const res = await dispatch(enableDisableEth3(token, boxDetails._id, boxDetails?.vpnAddress, updatedEth3Value))
    // const res = true
    console.log('res is ', res)
    if (res) {
      setEth3Value(updatedEth3Value)
    }
    setTimeout(() => {
      setE3Loading(false)
    }, 400)

  }

  return (
    <>
      <div className="optionsContainer">
        {isLoading && <Spinner />}
        <h1 className="font-weight-bold">{boxDetails?.eth0MacAddress ? 'Network Interface Info' : 'Netowrk'}</h1>
        {boxDetails?.eth0MacAddress && (
          <Row>
            <Col sm={12} md={12}>
            <table className="network-interface-info-table">
                <tr>
                  <th>Eth0 </th>
                  <th style={{ textAlign: 'center' }}>IP</th>
                  <th style={{ textAlign: 'center' }}>MAC Address</th>
                </tr>
                <tr>
                  <td></td>
                  <td>{boxDetails?.networkInterfaceInfo?.eth0?.ip}</td>
                  <td>{boxDetails?.networkInterfaceInfo?.eth0?.mac}</td>
                </tr>
              </table>
            </Col>
          </Row>
        )}
         <Row className='mb-3'>
          <Col sm={12} md={4}>
            {networkInfoLoading ? <SpinnerCircles red />
              : <Button color="primary" onClick={onRefreshNetworkInfo} title={'Fetch network info'}>
                Refresh Info
              </Button>}
          </Col>
        </Row>
        {user?.eth3Access && <Row className='mb-2'>
          <Col sm={6} md={4} id="test-enable-expansion-box" className="type-header d-flex">
            Enable Eth0/3
            <sup>
              <InfoPopup id="enable-exp-module" text={TOOLTIPS_TEXT.DISABLE_E3} />
            </sup>
          </Col>

          <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
            {e3loading ? (
              <SpinnerCircles red />
            ) : (
              <Toggle
                id="e3-switch-toggle"
                disabled={e3loading}
                value={!eth3Value}
                  onToggle={async toggleValue => setPasswordModal(true)}
              />
            )}
          </Col>
        </Row>}
        <Row>
          <Col sm={12} md={12}>
            <div hidden={boxDetails?.myEpik}>
              <NetworkInput
                tooltipId="e1-ip"
                tooltipText={TOOLTIPS_TEXT.E1_IP_TYPE}
                header="E1 IP Type"
                onToggle={handleDeactivateE1}
                value={e1Strings?.enabled}
                leftToggle="dhcp"
                rightToggle="Static"
              />
              {/* {e1Strings.enabled && (
      <>
        <NetworkInput
          header="E1 Primary IP"
          value={e1Strings.IP}
          name="IP"
          onChange={one2InputChange}
        />
        <NetworkInput
          header="E1 Subnet Mask"
          value={e1Strings.subnet}
          name="subnet"
          onChange={one2InputChange}
        />
        <NetworkInput
          header="E1 Gateway"
          value={e1Strings.gateway}
          name="gateway"
          onChange={one2InputChange}
        />
        <Col sm={6}>
          <Button
            className="w-100"
            disabled={enableE1Btn}
            color="primary"
            onClick={handleE2Save}
          >
            Save
          </Button>
        </Col>
      </>
    )} */}
              {e1Strings.enabled && (
                <Row className="e2-input-container">
                  <Col md={4} lg={3} className="pr-0">
                    <Label>Ip Address:</Label>
                    <Input
                      placeholder="Please specify"
                      value={e1Strings.IP}
                      type="text"
                      name="IP"
                      onChange={one2InputChange}
                      onkeypress={isNumberKey}
                    />
                  </Col>
                  <Col md={4} lg={3} className="pr-0">
                    <label>Subnet:</label>
                    <Input
                      placeholder="Please specify"
                      value={e1Strings.subnet}
                      type="text"
                      name="subnet"
                      onChange={one2InputChange}
                    />
                  </Col>
                  <Col md={4} lg={3} className="pr-0">
                    <Label>Gateway:</Label>
                    <Input
                      placeholder="Please specify"
                      value={e1Strings.gateway}
                      type="text"
                      name="gateway"
                      onChange={one2InputChange}
                    />
                  </Col>
                  <Col md={4} lg={3} className="e2-btn-container">
                    <Button disabled={enableE1Btn} color="primary" onClick={handleE2Save}>
                      Save
                    </Button>
                  </Col>
                </Row>
              )}
            </div>

            <br />
            <div hidden={boxDetails?.myEpik}>
              {toggleLoading ? (
                <div>
                  <SpinnerCircles red />
                </div>
              ) : (
                <NetworkInput
                  tooltipId="e2-dhcp"
                  tooltipText={TOOLTIPS_TEXT.E2_DHCP}
                  header="E2 DHCP"
                  onToggle={handleDeactivateE2}
                  value={DHCPStatus}
                  leftToggle="OFF"
                  rightToggle="ON"
                />
              )}
            </div>
            <br />

            {!boxDetails.myEpik && checkThirdOctet && (
              <Row>
                <Col id="call-recording-toggle" className="d-flex" sm={6}>
                  Port Forwarding:
                  <sup>
                    <InfoPopup id="port-forwading" text={TOOLTIPS_TEXT.PORT_FORWARD} />
                  </sup>
                </Col>
                <Col sm={6}>
                  {portLoading ? (
                    <SpinnerCircles red />
                  ) : (
                    <Button color="primary" onClick={onPortForwardPress}>
                      Port Forwarding
                    </Button>
                  )}
                </Col>
              </Row>
            )}
          </Col>
          {showWifiSection && !isModelGen4 && (
            <Col sm={12} md={6}>
              <h1 className="font-weight-bold">WIFI Network</h1>
              <NetworkInput disabled header="Status" value={wifiStatus?.Status} name="apn" input />
              <NetworkInput
                disabled={wifiStatus?.Status === 'Enabled'}
                header="SSID Name"
                value={wifiStatus?.SSID}
                name="SSID"
                onChange={onInputChange}
                input
              />

              <NetworkInput
                disabled={wifiStatus?.Status === 'Enabled'}
                header="Mode"
                dropdownOptions={modeDropDown}
                selectedOption={mode}
                onOptionSelect={e => handleDropDownChange(e, 'Mode')}
              />
              <NetworkInput
                disabled={wifiStatus?.Status === 'Enabled'}
                header="Security Options"
                dropdownOptions={secDropDown}
                selectedOption={sec}
                onOptionSelect={e => handleDropDownChange(e, 'Sec_Mode')}
              />

              <NetworkInput disabled header="IP" value={wifiStatus?.IP} name="IP" input />
              <NetworkInput
                disabled
                header="Subnet"
                value={wifiStatus?.Subnet}
                name="Subnet"
                input
              />
              <NetworkInput
                disabled
                header="Gateway"
                value={wifiStatus?.Gateway}
                name="Gateway"
                input
              />
              <NetworkInput
                disabled={wifiStatus?.Status === 'Enabled' || wifiStatus?.Sec_Mode === 'None'}
                header="Password"
                value={wifiStatus?.Password}
                showEye={wifiStatus?.Mode === 'AP'}
                name="Password"
                onChange={onInputChange}
                input
              />
              <Button color="primary" 
                  onClick={ () => {
                    const divElement = document.getElementById('test-time-remaining');
                    const isHidden = divElement.getAttribute('hidden') !== null;
                    if (isHidden) {
                      setDcUpdatePopup({ show: true });
                    } else {
                      handleConnectDisconnect()
                    }
        
                  }}
                >
                {loading ? (
                  <SpinnerCircles />
                ) : wifiStatus?.Status === 'Enabled' ? (
                  'Disconnect'
                ) : (
                  'Connect'
                )}
              </Button>
            </Col>
          )}
        </Row>
        {!boxDetails.myEpik && (
          <>
            {networkInfo?.interfaces && (
              <Row>
                <Col col={12} sm={12} md={7}>
                  <div>
                    <h1 className="headingnetwork-table">
                      INTERFACES - [{utils.getDateTimeFormat(networkInfo?.timestamp, 'both')}]
                    </h1>
                    <table className="network-status-table">
                      <tr className="full-filltable-row">
                        <th className="text-secondary">Name </th>
                        <th className="text-secondary">Internet </th>
                        <th className="text-secondary">ICMP </th>
                        <th className="text-secondary">Wireguard </th>
                        <th className="text-secondary">DNS</th>
                      </tr>
                      {networkInfo?.interfaces?.map((item, ind) => (
                        <tr className="full-filltable-row">
                          <td>{item?.interface}</td>
                          <TableRowData status={item?.internet} />
                          <TableRowData status={item?.icmp} />
                          <TableRowData status={item?.wg} />
                          {ind === 0 && (
                            <TableRowData status={networkInfo?.dns} interfaceName="dns" />
                          )}
                        </tr>
                      ))}
                    </table>
                  </div>
                </Col>
              </Row>
            )}
            {networkInfo?.tunnels && (
              <Row>
                <Col col={12} sm={12} md={7}>
                  <div>
                    <h1 className="headingnetwork-table">
                      TUNNELS - [{utils.getDateTimeFormat(networkInfo?.timestamp, 'both')}]
                    </h1>
                    <table className="network-status-table">
                      <tr className="full-filltable-row">
                        <th className="text-secondary">Name </th>
                        <th className="text-secondary">Connected </th>
                        <th className="text-secondary">IP</th>
                      </tr>
                      {networkInfo?.tunnels?.map(item => (
                        <tr className="full-filltable-row">
                          <td>{item?.interface}</td>
                          <TableRowData status={item?.status} />
                          <td>{item?.ip}</td>
                        </tr>
                      ))}
                    </table>
                  </div>
                </Col>
              </Row>
            )}
          </>
        )}
        <CustomModal
          header="Port Forward"
          wider
          isOpen={forwardingModal}
          onCancel={() => setForwardingModal(false)}
        >
          <PortForwardUpdate callback={onCallback} boxId={boxDetails._id} />
        </CustomModal>
        <ConfirmationModal
        bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
        headerText={'Device Lock Required'}
        confirmBtnText={'Lock & Edit'} 
        close={'No'} 
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton();
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
      </div>
      <div className="connectionButtonsContainer d-flex justify-content-end align-items-center w-100">
        <Button
          className="connectionButton mr-3"
          id="data-check-tip"
          color="primary"
          onClick={getNetworkStatus}
        >
          Fetch Result
        </Button>
        <div className="mr-3" onClick={refreshConnectivityStats}>
          <i className="fa fa-redo reload-toggle"></i>
        </div>
      </div>

      {warningModal && <ConfirmationModal
        isOpen={warningModal}
        onCancel={() => {
          setWarningModalText('');
          setWarningModal(false);
        }}
        confirmBtnText={'Proceed'}
        bodyText={warningModalText}
        // subHeader={currentModalData.type === 'datacenter' ? currentModalData?.subHeader : null}
        headerText={"Eth3 Port disabling"}
        onConfirm={onChangeEth3Value}
      />}

      {passwordModal && <AddSecurityCodeModal
        isOpen={passwordModal}
        onConfirm={eth3PasswordHandler}
        onCancel={() => setPasswordModal(false)}
        featureName={PIN_CODES_NAME.eth3Disable}
      />}
    </>
  );
});

export default EpikboxNetworking;
